  <template>

    <div class="prescription-popup">
        <div class="content-prescription">
            <div class="popup-header">
                <div class="popup-header-title">Prescription details</div>
                <div class="right-header">

                  
                  <template v-if="prescription.readability">
                    <div class="readability-badge low" v-if="prescription.readability=='bad'">
                      Low readability
                    </div>
                    <div class="readability-badge good" v-if="prescription.readability=='good'">
                      High readability
                    </div>
                    <div class="readability-badge medium" v-if="prescription.readability=='medium'">
                      Medium readability
                    </div>
                  </template>
                
                  <div class="cross" @click="closePrescriptionPopup()"><img src="@/assets/images/close.svg" /></div>
                </div>
            </div>
           
            <div class="prescription-content" v-if="loaded">
                <div class="left-side">
                  <div class="prescription-info">
                      <div class="prescription-info-left">
                      
                          <div class="icon"><img src="@/assets/images/doc.svg" /></div>
                          
                          <div class="name">{{prescription.name}}</div>

                      </div>
                      <div class="date">{{prescription.date}}</div>
                  </div>
                  <div class="prescription-image">
                    <template v-if="prescription.file">
                      <img v-if="isImage(prescription.file)" :src="prescription.file" />
                      <img v-else-if="isPdf(prescription.file) && pdfPreviewUrl" :src="pdfPreviewUrl" alt="PDF preview" />
                      <div v-else-if="isPdf(prescription.file) && pdfPreviewLoading" class="pdf-loader">
                        <div class="spinner" />
                      </div>
                      <div v-else-if="isPdf(prescription.file) && pdfFallbackSrc" class="pdf-fallback">
                        <object :data="pdfFallbackSrc" type="application/pdf">
                          <img src="@/assets/images/doc.svg" />
                        </object>
                      </div>
                      <img v-else src="@/assets/images/doc.svg" />
                    </template>
                    <img v-else src="@/assets/images/doc.svg" />
                  </div>
                  <div class="buttons">
                    <a class="button-dl" v-if="prescription.file" :href="prescription.file" target="_blank" ><img class="w" src="@/assets/images/eye.svg" />Preview</a>
                    <a class="button-dl" variant="primary" @click="downloadPrescription(prescription.name)"><img src="@/assets/images/dl.svg" />Download</a>
                  </div>
                </div>
                <div class="right-side" id="element-to-convert2">
                  <table class="table prescription-table">
                      <tr>
                          <td></td>
                        
                          <td><center>Right eye (OD)</center></td>
                          
                          <td><center>Left eye (OG)</center></td>
                        
                          
                      </tr>
                      <tr>
                      
                          <td>Sphere</td>
                          <td><div class="value">{{(prescription.right_sphere!=''&&prescription.right_sphere!=null)?prescription.right_sphere:'-'}}</div></td>
                          <td><div class="value">{{(prescription.left_sphere!=''&&prescription.left_sphere!=null)?prescription.left_sphere:'-'}}</div></td>
                          
      
                      </tr>
                      <tr>
                          
                          <td>
                            <template v-if="language=='fr'">
                              Cylindre
                            </template>
                            <template v-else>
                              Cylinder
                            </template>
                          </td>
                          <td><div class="value">{{(prescription.right_cylinder!=''&&prescription.right_cylinder!=null)?prescription.right_cylinder:'-'}}</div></td>
                          <td><div class="value">{{(prescription.left_cylinder!=''&&prescription.left_cylinder!=null)?prescription.left_cylinder:'-'}}</div></td>
                        
                          
                      </tr>
                      <tr>
                      
                        <td>Addition</td>
                        <td><div class="value">{{(prescription.right_addition!=''&&prescription.right_addition!=null)?prescription.right_addition:'-'}}</div></td>
                        <td><div class="value">{{(prescription.left_addition!=''&&prescription.left_addition!=null)?prescription.left_addition:'-'}}</div></td>
                      </tr>
                      <tr>
                      
                        <td> 
                          <template v-if="language=='fr'">
                            Axe
                          </template>
                          <template v-else>
                            Axis
                          </template>
                        </td>
                        <td><div class="value">{{(prescription.right_axis!=''&&prescription.right_axis!=null)?prescription.right_axis:'-'}}</div></td>
                        <td><div class="value">{{(prescription.left_axis!=''&&prescription.left_axis!=null)?prescription.left_axis:'-'}}</div></td>
                      
                       
                      </tr>
                      <template v-if="(prescription.left_prism != '' && prescription.left_prism != null)">

                      <tr>   
                        <td>Prism</td>      
                          <td><div class="value">{{(prescription.left_prism!=''&&prescription.left_prism!=null)?prescription.left_prism:'-'}}</div></td>
                          <td><div class="value">{{(prescription.right_prism!=''&&prescription.right_prism!=null)?prescription.right_prism:'-'}}</div></td>
                      </tr>
                      <tr>   
                        <td>Prism Base</td>      
                          <td><div class="value">{{(prescription.left_prism_base!=''&&prescription.left_prism_base!=null)?prescription.left_prism_base:'-'}}</div></td>
                          <td><div class="value">{{(prescription.right_prism_base!=''&&prescription.right_prism_base!=null)?prescription.right_prism_base:'-'}}</div></td>
                      </tr>

                      </template>
                      <template v-if="(prescription.pupillary_distance != '' && prescription.pupillary_distance != null) || (prescription.left_pupillary_distance != '' && prescription.left_pupillary_distance != null) || (prescription.right_pupillary_distance != '' && prescription.right_pupillary_distance != null)">
                        <tr>
                          <td class="white" colspan="3">
                            <div class="legend">Optional</div>
                            <div class="bar"></div>
                          </td>
                        </tr>

                        <tr>
                        
                          <td>Pupillary distance</td>
                          <template v-if="prescription.pupillary_distance != '' && prescription.pupillary_distance != null">
                            <td colspan="2"><div class="value">{{(prescription.pupillary_distance!=''&&prescription.pupillary_distance!=null)?prescription.pupillary_distance:'-'}}</div></td>
                          </template>
                          <template v-else>
                            <td><div class="value">{{(prescription.left_pupillary_distance!=''&&prescription.left_pupillary_distance!=null)?prescription.left_pupillary_distance:'-'}}</div></td>
                            <td><div class="value">{{(prescription.right_pupillary_distance!=''&&prescription.right_pupillary_distance!=null)?prescription.right_pupillary_distance:'-'}}</div></td>
                          </template>

                      </tr>
                    </template>
                  </table>


                  <div class="prescription-description" v-if="prescription.description != '' && prescription.description != null">
                  <img src="@/assets/images/eye_green.svg" />
                  <div>
                      {{prescription.description}}
                  </div>
                  </div>
                </div>
               
            </div>
        </div>
    </div>
  </template>
  
  
  <script>

  import {BModal, BButton,BOverlay, VBModal, BRow, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
  import {APIRequest, Auth} from '@simb2s/senseye-sdk'
  import { VueGoodTable } from 'vue-good-table'
  import ScanPopup from '../../components/ScanPopup.vue'
  import AdjustmentReport from '../order-review/AdjustmentReport.vue'
  import PrescriptionPopup from '../../components/PrescriptionPopup.vue'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import emitter from 'tiny-emitter/instance'
  import html2pdf from "html2pdf.js";

  export default {
    components: {
      BCard,
      BCardText,
      VueGoodTable,
            BAvatar,
      BOverlay,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
      BModal,
      BButton,
      BRow,
      ScanPopup,
      PrescriptionPopup,
      AdjustmentReport
    },
    props:['prescription_id'],
    data() {
      return {
        prescription:null,
        loaded:false,
        language:'en',
        pdfPreviewUrl: null,
        pdfPreviewLoading: false,
        pdfFallbackSrc: null,
      }
    },
    computed: {
     
    },
    methods:{
        downloadPrescription (name='prescription') {
          // Generate PDF - image is already converted to base64
          html2pdf(document.getElementById("element-to-convert2"), {
            margin: 0,
            
            filename: name+".pdf",
            image: { type: 'jpg', quality: 0.98 },
            html2canvas: { 
              useCORS: true,
              scale: 2,
              logging: false,
              backgroundColor: "#e4e3e1"
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', backgroundColor: "#e4e3e1" }
          });
        },
        closePrescriptionPopup() {
            this.$emit('closePrescriptionPopupEv')
        },
        getExtension(filename) {
          if (!filename) return ''
          const clean = filename.split('?')[0].split('#')[0]
          return clean.split('.').pop().toLowerCase()
        },
        isImage(filename) {
          const extension = this.getExtension(filename)
          return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'ico', 'webp'].includes(extension)
        },
        isPdf(filename) {
          return this.getExtension(filename) === 'pdf'
        },
        loadPdfJs() {
          if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib)
          return new Promise((resolve, reject) => {
            const script = document.createElement('script')
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.min.js'
            script.onload = () => {
              window.pdfjsLib.GlobalWorkerOptions.workerSrc =
                'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js'
              resolve(window.pdfjsLib)
            }
            script.onerror = reject
            document.head.appendChild(script)
          })
        },
        async fetchPdfBytes(url) {
          const token = typeof localStorage !== 'undefined' ? localStorage.token_senseye_auth : null
          const authHeaders = token ? { Authorization: `Bearer ${token}` } : {}
          const candidates = []

          // Same-origin dev proxy (vue.config.js) — avoids CORS for api.sens-eye.fr
          if (url.includes('api.sens-eye.fr')) {
            const path = url.replace(/^https?:\/\/[^/]+/, '')
            candidates.push({ url: `/api-proxy${path}`, headers: authHeaders })
          }

          // S3 signed URLs (scan-storage / amazonaws) — proxy in dev to avoid CORS
          try {
            const parsed = new URL(url)
            if (parsed.hostname.includes('amazonaws.com') && parsed.hostname.includes('s3')) {
              candidates.push({
                url: `/s3-proxy/${parsed.hostname}${parsed.pathname}${parsed.search}`,
                headers: {},
              })
            }
          } catch (e) {
            // ignore invalid URL
          }

          candidates.push({ url, headers: {} })

          let lastError = null
          for (const candidate of candidates) {
            try {
              const res = await fetch(candidate.url, { headers: candidate.headers })
              if (!res.ok) throw new Error(`HTTP ${res.status}`)
              return await res.arrayBuffer()
            } catch (e) {
              lastError = e
            }
          }
          throw lastError || new Error('Unable to fetch PDF')
        },
        async renderPdfPreview(url) {
          this.pdfPreviewLoading = true
          this.pdfPreviewUrl = null
          this.pdfFallbackSrc = null
          try {
            const [pdfjsLib, data] = await Promise.all([
              this.loadPdfJs(),
              this.fetchPdfBytes(url),
            ])
            const pdf = await pdfjsLib.getDocument({ data }).promise
            const page = await pdf.getPage(1)
            const unscaled = page.getViewport({ scale: 1 })
            const targetWidth = 600
            const scale = targetWidth / unscaled.width
            const viewport = page.getViewport({ scale })
            const canvas = document.createElement('canvas')
            canvas.width = viewport.width
            canvas.height = viewport.height
            await page.render({
              canvasContext: canvas.getContext('2d'),
              viewport,
            }).promise
            this.pdfPreviewUrl = canvas.toDataURL('image/jpeg', 0.92)
          } catch (e) {
            console.warn('PDF preview failed', e)
            this.pdfPreviewUrl = null
            // Fallback: native PDF viewer (no CORS read needed)
            this.pdfFallbackSrc = `${url.split('#')[0]}#page=1&toolbar=0&navpanes=0&scrollbar=0&view=FitH`
          } finally {
            this.pdfPreviewLoading = false
          }
        }
    },
    async mounted() {
      this.prescription=await APIRequest.detail('prescriptions',this.prescription_id)
      if (this.prescription && this.prescription.file && this.isPdf(this.prescription.file)) {
        this.pdfPreviewLoading = true
        this.loaded = true
        this.renderPdfPreview(this.prescription.file)
      } else {
        this.loaded = true
      }
    }
  
  }
  
  
    </script>
  
    <style scoped lang="scss" >
  @import '@core/scss/vue/libs/vue-good-table.scss';
  .prescription-description
  {
    background:#f1f1f1;
    padding:20px;
    border-radius: 5px;
    display: flex;
    align-items: flex-start;
    gap:10px;
    margin-top:20px;
    img
    {
      width:20px;
     
    }
    
  }
  .prescription-info
  {
    width:100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    background: #fff;
    padding:5px 10px 5px 5px;
    border-radius: 5px;
    .prescription-info-left
    {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .icon
    {
        width:32px;
        height:32px;
        display:flex;
        background: #fff;
        border-radius: 5px;
        padding: 5px;
        align-items: center;
        justify-content: center;
    }
    .name
    {
        
    }
    .date
    {
        font-size:14px;
        color: #999;
    }
  }
 .cross
 {
    cursor: pointer;
    width:32px;
   
    height:32px;
    display:flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background: #f1f1f1;
    img
    {
        width:10px;
    }
 }
  .popup-header
  {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    border-bottom: 1px solid #f1f1f1;
    padding-bottom: 20px;
    .popup-header-title
    {
        font-size:22px;
        font-weight:600;
    }
  }
  .prescription-popup
  {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.1);
    z-index: 9999;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    .content-prescription
    {
        
        min-width:600px;
        max-width:900px;
        width:80%;
        height:fit-content;
        background: #fff;
        border-radius: 5px;
        padding: 20px;
    }
  }
  tr 
  {
    border:0 !important;
  }
  td.white .bar 
  {
    background:#999 !important;
    height:1px !important;
    width:100% !important;
    position:absolute;
    top:50%;
    z-index:1;
    left:0;
    transform: translateY(-50%);
  }
  td.white .legend 
  {
    padding:10px;
    background:#fff !important;
    position:absolute;
    top:50%;
    z-index:2;
    left:50%;
    transform: translate(-50%,-50%);
 
  }
  td.white
  {
    position:relative;
    color:#999;
    text-align: center;
  }
  td
  {
    border:0 !important;
   
    padding:10px;
   
    .value 
    {
      background:#f1f1f1;
      padding:10px;
      border-radius: 5px;
      width:100%;
      text-align: center;
    }
  }
  .readability-badge
  {
    padding:5px 10px;
    border-radius: 5px;
    font-size:12px;
    line-height:21px;
    width:fit-content;
   
    &.low
    {
      color:#F90;
      background:#fff0d9;
    }
    &.good
    {
      color:#10c05f;
      background:#dbf6e7;
    }
    &.medium
    {
      color:#08f;
      background:#d9edff;
    }
  }
  .right-header
  {
    display:flex;
    gap:10px;
  }
  .prescription-content
  {
    display: flex;
    align-items: stretch;
    gap:20px;
    justify-content: space-between;
    .left-side
    {
      width:40%;
      background: #f1f1f1;
      padding:20px;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      gap:20px;
      justify-content: space-between;
      align-items: center;
      .buttons
      {
        display: flex;
        gap:10px;
        width:100%;
        justify-content: flex-start;
      }
    }
    .right-side
    {
      width:60%;
    }
  }
  .prescription-image
  {
    width:60%;
    img
    {
      width:100%;
      height:auto;
      border-radius: 5px;
      display: block;
    }
    .pdf-loader
    {
      width: 100%;
      min-height: 180px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      border-radius: 5px;
    }
    .spinner
    {
      width: 28px;
      height: 28px;
      border: 2px solid #e5e5e5;
      border-top-color: #666;
      border-radius: 50%;
      animation: pdf-spin 0.7s linear infinite;
    }
    .pdf-fallback
    {
      width: 100%;
      height: 280px;
      overflow: hidden;
      border-radius: 5px;
      background: #fff;
      pointer-events: none;
      object,
      embed,
      iframe
      {
        width: 100%;
        height: 140%;
        border: 0;
        display: block;
        transform: scale(1.05);
        transform-origin: top center;
      }
    }
  }
  @keyframes pdf-spin
  {
    to { transform: rotate(360deg); }
  }
  .button-dl
  {
    display: flex;
    align-items: center;
    gap:5px;
    padding:8px 15px;
    border-radius: 5px;
    background:#fff;
    color:#000;
    img
    {
      width:15px;
      &.w
      {
        filter: invert(1);
      }
    }
  }
  </style>